import { useMutation } from "@tanstack/react-query";
import {
  getXReport,
  getZReport,
  printFmReport,
  cashIn,
  cashOut,
} from "../api/operations";
import type {
  FiscalOperationResponse,
  CashOperationIn,
  FmReportIn,
} from "../api/operations";

/**
 * Custom hook за извикване на X отчет
 * Използва React Query за управление на async заявката
 */
export const useXReport = () => {
  return useMutation<FiscalOperationResponse, Error>({
    mutationFn: getXReport,
  });
};

/**
 * Custom hook за извикване на Z отчет
 * Използва React Query за управление на async заявката
 */
export const useZReport = () => {
  return useMutation<FiscalOperationResponse, Error>({
    mutationFn: getZReport,
  });
};

/**
 * Custom hook за X отчет за период (отчет от фискалната памет)
 * Приема вид + период и ги изпраща към backend-а
 */
export const useFmReport = () => {
  return useMutation<FiscalOperationResponse, Error, FmReportIn>({
    mutationFn: printFmReport,
  });
};

/**
 * Custom hook за служебно въвеждане (cash-in)
 * Приема сума и я изпраща към backend-а
 */
export const useCashIn = () => {
  return useMutation<FiscalOperationResponse, Error, CashOperationIn>({
    mutationFn: cashIn,
  });
};

/**
 * Custom hook за служебно извеждане (cash-out)
 * Приема сума и я изпраща към backend-а
 */
export const useCashOut = () => {
  return useMutation<FiscalOperationResponse, Error, CashOperationIn>({
    mutationFn: cashOut,
  });
};
